// extracted by mini-css-extract-plugin
module.exports = {"Icon":"_3hzEfyT3clcp46AXaVjZZH"};